import { HTTP } from '@/api/http-common';

export function Roles() {
	return {
		create(payload) {
			return HTTP.post('roles', payload);
		}
	};
}

export function Role(roleId) {
	const roleEndpoint = `roles/${roleId}`;

	return {
		activate() {
			return HTTP.post(`${roleEndpoint}/activate`);
		},
		deactivate() {
			return HTTP.post(`${roleEndpoint}/deactivate`);
		},
		delete() {
			return HTTP.delete(roleEndpoint);
		},
		duplicate() {
			return HTTP.post(`${roleEndpoint}/duplicate`);
		},
		modify(payload) {
			return HTTP.patch(roleEndpoint, payload);
		},
		setPosition(position) {
			return HTTP.post(`${roleEndpoint}/position`, { value: position });
		},
		Permission(permissionId) {
			return {
				enable() {
					return HTTP.post(`${roleEndpoint}/permissions/${permissionId}/enable`);
				},
				disable() {
					return HTTP.post(`${roleEndpoint}/permissions/${permissionId}/disable`);
				}
			};
		}
	};
}

export function Teams() {
	return {
		create(payload) {
			return HTTP.post('teams', payload);
		}
	};
}

export function Team(teamId) {
	const teamEndpoint = `teams/${teamId}`;

	return {
		activate() {
			return HTTP.post(`${teamEndpoint}/activate`);
		},
		deactivate() {
			return HTTP.post(`${teamEndpoint}/deactivate`);
		},
		delete() {
			return HTTP.delete(teamEndpoint);
		},
		modify(payload) {
			return HTTP.patch(teamEndpoint, payload);
		},
	};
}

export function Shared(hash) {
	const sharedEndpoint = `shared/${hash}`;

	return {
		getAssignmentData() {
			return HTTP.get(sharedEndpoint);
		},
		insertFilesTopic(dataFiles) {
			return HTTP.post(`${sharedEndpoint}/files/insert-files`, {dataFiles});
		},
		addVisitor() {
			return HTTP.post(`${sharedEndpoint}/visitors`);
		},
		getAvailableUsers() {
			return HTTP.get(`${sharedEndpoint}/available-users`);
		},
		getApprovalStatus() {
			return HTTP.get(`${sharedEndpoint}/approval-status`);
		},
		saveVersion() {
			return HTTP.post(`${sharedEndpoint}/versions`);
		},
		resizeImage(key) {
			return HTTP.post(`${sharedEndpoint}/resize-image`, { key });
		},
		checkAccessTopic(userIds) {
			return HTTP.post(`${sharedEndpoint}/check-access-topic`, {userIds});
		},
		Files() {
			const filesEndpoint = `${sharedEndpoint}/files`

			return {
				get(fileIds) {
					return HTTP.get(`${filesEndpoint}/fetch`, {
						params: {
							ids: fileIds
						},
					});
				}
			}
		},
		File(key) {
			const filesEndpoint = `${sharedEndpoint}/files`;

			return {
				delete(widgetId) {
					return HTTP({
						method: 'DELETE',
						url: filesEndpoint,
						data: { key, widgetId }
					});
				},
				download() {
					return HTTP.get(filesEndpoint, {
						params: { key },
						responseType: 'blob'
					});
				}
			};
		},
		Widget(id) {
			const widgetEndpoint = `${sharedEndpoint}/widgets/${id}`;

			return {
				saveValue(value) {
					return HTTP.post(widgetEndpoint, value);
				},
				addComment(payload) {
					return HTTP.post(`${widgetEndpoint}/comments`, payload);
				}
			};
		},
		Comments() {
			return {
				fetch() {
					return HTTP.get(`${sharedEndpoint}/comments`);
				},
				add(comment) {
					return HTTP.post(`${sharedEndpoint}/comments`, { comment });
				}
			};
		},
		Comment(commentId) {
			const commentEndpoint = `${sharedEndpoint}/comments/${commentId}`;

			return {
				delete() {
					return HTTP.delete(commentEndpoint);
				},
				modifyText(comment) {
					return HTTP.patch(commentEndpoint, { comment });
				},
				resolve() {
					return HTTP.post(`${commentEndpoint}/resolve`);
				},
				unResolve() {
					return HTTP.post(`${commentEndpoint}/unresolved`);
				},
				addReply(comment) {
					return HTTP.post(`${commentEndpoint}/replies`, { comment });
				},
				Reply(replyId) {
					const replyEndpoint = `${commentEndpoint}/replies/${replyId}`;

					return {
						delete() {
							return HTTP.delete(replyEndpoint);
						},
						modifyText(comment) {
							return HTTP.patch(replyEndpoint, { comment });
						}
					};
				},
				Meta() {
					return {
						update(meta) {
							return HTTP.patch(`${commentEndpoint}/meta`, { meta });
						}
					}
				}
			};
		}
	};
}

export function Users() {
	return {
		Guests() {
			return {
				get(params) {
					return HTTP.get('users/guests', params ? { params } : { });
				},
			};
		}
	};
}

export function User(userId) {
	let usersEndpoint = `users/${userId}`;

	return {
		get(params) {
			return HTTP.get(usersEndpoint, params ? { params } : { });
		},
		permissions() {
			return HTTP.get(`${usersEndpoint}/permissions`);
		},
		logOut() {
			return HTTP.post(`${usersEndpoint}/logout`);
		},
		editGuestProfile(payload) {
			return HTTP.patch(`${usersEndpoint}/guest-profile`, payload);
		},
		guestPasswordReset(payload) {
			return HTTP.patch(`${usersEndpoint}/guest-password-reset`, payload);
		},
		projects() {
			return HTTP.get(`${usersEndpoint}/projects`);
		},
		createProjectBookmark(projectId) {
			return HTTP.post(`${usersEndpoint}/project-bookmarks`, {projectId});
		},
		deleteProjectBookmark(bookmarkId) {
			return HTTP.delete(`${usersEndpoint}/project-bookmarks/${bookmarkId}`);
		}
	};
}

export function Project(projectId, hash = '') {
	let projectEndpoint = !hash ? `projects/${projectId}` : `shared/${hash}`;

	return {
		ContentItems() {
			let contentItemsEndpoint = `${projectEndpoint}/content-items`;

			return {
				getHierarchy(params) {
					return HTTP.get(`${contentItemsEndpoint}/hierarchy`, params ? { params } : { });
				},
				claim(id) {
					return HTTP.patch(`${contentItemsEndpoint}/${id}/claim`);
				},
				updatePositionItem(data) {
					return HTTP.patch(`${contentItemsEndpoint}/update-position-item`, data);
				},
				changeTemplateArticles(data) {
					return HTTP.patch(`${contentItemsEndpoint}/change-template`, data);
				},
				changeStatusArticles(data) {
					return HTTP.patch(`${contentItemsEndpoint}/change-status`, data);
				},
				changeCategoryArticles(data) {
					return HTTP.patch(`${contentItemsEndpoint}/change-category`, data);
				},
				duplicateArticle(contentItemId, newTitle) {
					return HTTP.post(`${contentItemsEndpoint}/${contentItemId}/duplicate`, {contentItemId, newTitle});
				},
				convertToBrief(articleIds) {
					return HTTP.patch(`${contentItemsEndpoint}/convert-to-brief`, {topicsIDs: articleIds});
				},
				deleteContentItems(articleIds, folderIds) {
					return HTTP({
						method: 'DELETE',
						url: `${contentItemsEndpoint}/delete`,
						data: {topicsIDs: articleIds, foldersIDs: folderIds}
					});
				},
				createArticle(data) {
					return HTTP.post(`${contentItemsEndpoint}/create-article`, data);
				},
				createFolder(data) {
					return HTTP.post(`${contentItemsEndpoint}/create-folder`, data);
				},
				updateFolderItem(data) {
					return HTTP.patch(`${contentItemsEndpoint}/update-folder-item`, data);
				},
				updateArticleItem(data) {
					return HTTP.patch(`${contentItemsEndpoint}/update-article-item`, data);
				},
				canReserve(articleIds) {
					return HTTP.get(`${contentItemsEndpoint}/can-reserve`, {params: {articleIds}});
				},
				limitReached() {
					return HTTP.get(`${contentItemsEndpoint}/limit-reached`);
				},
			};
		},
		Assignment(assignmentId) {
			let assignmentEndpoint = `${projectEndpoint}/assignments/${assignmentId}`;

			return {
				itemHasContent() {
					return HTTP.get(`${assignmentEndpoint}/item-has-content`);
				},
				getUsersAvailableInComments() {
					return HTTP.get(`${assignmentEndpoint}/comments/users/available`);
				},
				get(params) {
					return HTTP.get(assignmentEndpoint, params ? { params } : { });
				},
				reject(payload) {
					return HTTP.post(`${assignmentEndpoint}/reject`, payload);
				},
				saveVersion() {
					return HTTP.post(`${projectEndpoint}/articles/${assignmentId}/versions`);
				},
				approve(payload) {
					return HTTP.post(`${assignmentEndpoint}/approve`, payload);
				},
				publish(payload) {
					return HTTP.post(`${assignmentEndpoint}/publish`, payload);
				},
				changeStatus(newStatusId) {
					return HTTP.post(`${assignmentEndpoint}/change-status-to/${newStatusId}`);
				},
				updateDetails(data) {
					return HTTP.put(`${assignmentEndpoint}/details`, data);
				},
				setCurrentUserResponsible() {
					return HTTP.post(`${assignmentEndpoint}/set-current-user-responsible`);
				},
				resizeImage(key) {
					return HTTP.post(`${assignmentEndpoint}/resize-image`, { key });
				},
				addComment(comment) {
					return HTTP.post(`${assignmentEndpoint}/comments`, { comment });
				},
				Review() {
					return {
						cancel() {
							return HTTP.post(`${assignmentEndpoint}/review/cancel`);
						}
					}
				},
				Comment(commentId) {
					const commentEndpoint = `${assignmentEndpoint}/comments/${commentId}`;

					return {
						delete() {
							return HTTP.delete(commentEndpoint);
						},
						resolve() {
							return HTTP.post(`${commentEndpoint}/resolve`);
						},
						unResolve() {
							return HTTP.post(`${commentEndpoint}/unresolved`);
						},
						changeText(comment) {
							return HTTP.patch(commentEndpoint, { comment });
						},
						addReply(comment) {
							return HTTP.post(`${commentEndpoint}/replies`, { comment });
						},
						Reply(replyId) {
							const replyEndpoint = `${commentEndpoint}/replies/${replyId}`;

							return {
								delete() {
									return HTTP.delete(replyEndpoint);
								},
								changeText(comment) {
									return HTTP.patch(replyEndpoint, { comment });
								}
							};
						},
						Meta() {
							return {
								update(meta) {
									return HTTP.patch(`${commentEndpoint}/meta`, { meta });
								}
							};
						}
					};
				},
				Messages() {
					let messagesEndpoint = `${assignmentEndpoint}/messages`;

					return {
						get(params) {
							return HTTP.get(messagesEndpoint, params ? { params } : { });
						},
						markAsRead() {
							return HTTP.post(`${messagesEndpoint}/mark-as-read`);
						}
					};
				},
				Message(messageId) {
					let messageEndpoint = `projects/${projectId}/assignments/${assignmentId}/messages/${messageId}`;

					return {
						delete() {
							return HTTP.delete(messageEndpoint);
						}
					}
				},
				File(key) {
					return {
						delete(widgetId) {
							return HTTP({
								method: 'DELETE',
								url: `${assignmentEndpoint}/files`,
								data: { key, widgetId }
							});
						},
						download() {
							return HTTP.get(`${assignmentEndpoint}/files`, {
								params: { key },
								responseType: 'blob'
							});
						}
					};
				},
				Versions() {
					return {
						get(params) {
							return HTTP.get(`${projectEndpoint}/articles/${assignmentId}/versions`, { params })
						},
						diff(olderVersionId, newerVersionId) {
							return HTTP.get(`${projectEndpoint}/articles/${assignmentId}/versions/${olderVersionId}/diff/${newerVersionId}`)
						},
					}
				},
				Version(versionId) {
					const versionEndpoint = `${projectEndpoint}/articles/${assignmentId}/versions/${versionId}`

					return {
						setName(payload) {
							// TODO: Change "payload" to "name" because we already have info about version ID in endpoint
							return HTTP.put(`${versionEndpoint}/name`, payload)
						},
						toArticle(payload) {
							return HTTP.post(`${versionEndpoint}/to-article`, payload)
						},
						delete() {
							return HTTP.delete(versionEndpoint)
						},
						get() {
							return HTTP.get(versionEndpoint)
						},
						restore() {
							return HTTP.post(`${versionEndpoint}/restore`)
						},
					}
				},
				Widget(widgetId) {
					let widgetEndpoint = `${assignmentEndpoint}/widgets/${widgetId}`;

					return {
						saveValue(value) {
							return HTTP.post(widgetEndpoint, value);
						},
						addComment(payload) {
							return HTTP.post(`${widgetEndpoint}/comments`, payload);
						}
					};
				},
				Link() {
					let linkEndpoint = `${assignmentEndpoint}/shareable-link`;

					return {
						get() {
							return HTTP.get(linkEndpoint);
						},
						updateField(params) {
							return HTTP.post(linkEndpoint, params);
						},
						sendNotifications(payload) {
							return HTTP.post(`${linkEndpoint}/send-notifications`, payload);
						}
					};
				},
				insertFilesTopic(dataFiles) {
					return HTTP.post(`${assignmentEndpoint}/insert-files`, {dataFiles});
				},
				getFilesTopic() {
					return HTTP.get(`${assignmentEndpoint}/get-files`);
				},
				checkAccessTopic(userIds) {
					return HTTP.post(`${assignmentEndpoint}/check-access-topic`, {userIds});
				},
			};
		},
		Statuses() {
			return {
				get(params) {
					let endpoint = `${projectEndpoint}/statuses`;
					let config = params ? { params } : { };
					return HTTP.get(endpoint, config);
				}
			};
		},
		AssignedPeople() {
			return {
				get(params) {
					let endpoint = `${projectEndpoint}/assigned-people`;
					let config = params ? { params } : { };
					return HTTP.get(endpoint, config);
				}
			};
		},
		Categories() {
			return {
				get() {
					return HTTP.get(`${projectEndpoint}/categories`);
				}
			};
		},
		Templates() {
			const templatesEndpoint = `${projectEndpoint}/templates`;

			return {
				get() {
					return HTTP.get(templatesEndpoint);
				},
			};
		},
		TemplateSettings() {
			const templateSettingEndpoint = `${projectEndpoint}/template-settings`;

			return {
				get() {
					return HTTP.get(`${templateSettingEndpoint}`);
				},
				getTemplates() {
					return HTTP.get(`${templateSettingEndpoint}/get-templates`);
				},
				createTemplate(payload) {
					return HTTP.post(`${templateSettingEndpoint}`, payload);
				},

				Template(templateId) {
					const templateEndpoint = `${templateSettingEndpoint}/${templateId}`;

					return {
						cloneIntoAnotherProject(payload) {
							return HTTP.post(`${templateEndpoint}/clone-into-another-project`, payload);
						},
						delete() {
							return HTTP.delete(`${templateEndpoint}`);
						},
						duplicate() {
							return HTTP.post(`${templateEndpoint}/duplicate`);
						},
						update(payload) {
							return HTTP.patch(`${templateEndpoint}`, payload);
						},
						fields() {
							return HTTP.get(`${templateEndpoint}/fields`);
						},

						Tab(tabId) {
							const tabEndpoint = `${templateEndpoint}/tabs/${tabId}`;

							return {
								duplicate() {
									return HTTP.post(`${tabEndpoint}/duplicate`);
								},
							}
						}

					}
				}
			}
		},
		WpData() {
			// TODO: Try to fetch directly from WordPress
			return {
				getTagsWp() {
					return HTTP.get(`${projectEndpoint}/get-tags-wp`);
				},
				getCategoriesWp() {
					return HTTP.get(`${projectEndpoint}/get-categories-wp`);
				},
				getCategoriesTagsWp() {
					return HTTP.get(`${projectEndpoint}/get-categories-tags-wp`);
				},
			}
		},
		Users() {
			const usersEndpoint = `${projectEndpoint}/users`;

			return {
				active() {
					return HTTP.get(`${usersEndpoint}/active`);
				},
			};
		},
		Export() {
			const exportEndpoint = `${projectEndpoint}/exports`;

			return {
				articlesToFile(data) {
					return HTTP.post(`${exportEndpoint}/to-${data.type}`, { topicIds: data?.topicIds ?? [], projectId: data?.projectId ?? null });
				},
			}
		},
		Import() {
			const importEndpoint = `${projectEndpoint}/import`;

			return {
				contentItems(data) {
					return HTTP.post(`${importEndpoint}/content-items`, data);
				},
			}
		},
		Files(keys = []) {
			const filesEndpoint = 'files';

			return {
				fetch(fileIds) {
					return HTTP.get(`${projectEndpoint}/files`, {
						params: {
							ids: fileIds,
						}
					});
				},
				get() {
					return HTTP.get(`${projectEndpoint}/${filesEndpoint}/view-files`);
				},
				getDataFiles(filter, sort, countValues) {
					return HTTP.post(`${projectEndpoint}/${filesEndpoint}/get-files`, {filter, sort, countValues});
				},
				delete() {
					return HTTP({
						method: 'DELETE',
						url: `${projectEndpoint}/${filesEndpoint}/delete`,
						data: {keys: JSON.stringify(keys)}
					});
				},
				download(type = '') {
					return HTTP.get(`${projectEndpoint}/${filesEndpoint}/download`, {
						params: {keys, type: type},
						responseType: 'blob'
					});
				},
				filesIconHtml() {
					return HTTP.get(`${projectEndpoint}/get-file-icon-html`, {
						params: {filenames: JSON.stringify(keys)},
					});
				},
				createFolderFiles() {
					return HTTP.get(`${projectEndpoint}/${filesEndpoint}/create-folder-files`, {
						params: {keys: JSON.stringify(keys)},
					});
				},
				updateFolderFiles(folders_files_id, name) {
					return HTTP.post(`${projectEndpoint}/${filesEndpoint}/update-folder-files`, {folders_files_id, name});
				},
				addFiles(folders_files_id, filter, sort) {
					return HTTP.post(`${projectEndpoint}/${filesEndpoint}/add-files`, {keys, folders_files_id, filter, sort});
				},
				moveToFolder(folders_files_id) {
					return HTTP.post(`${projectEndpoint}/${filesEndpoint}/move-to-folder`, {keys, folders_files_id});
				},
				deleteFolderWithFiles(folders_files_id, deleteFiles) {
					return HTTP.post(`${projectEndpoint}/${filesEndpoint}/delete-folder-with-files`, {deleteFiles, folders_files_id});
				},
			};
		},
		Messages() {
			let messagesEndpoint = `${projectEndpoint}/messages`;

			return {
				get(params) {
					return HTTP.get(messagesEndpoint, {params});
				},
				markAsRead(params) {
					return HTTP.post(`${messagesEndpoint}/mark-as-read`, params);
				}
			};
		},
	};
}

export function Settings() {
	const settingsEndpoint = 'settings';

	return {
		getData() {
			return HTTP.get(settingsEndpoint);
		},
		createThemeCustomization(data) {
			return HTTP.post(`${settingsEndpoint}/create-theme-customization`, data);
		},
		updateThemeCustomization(data) {
			return HTTP.put(`${settingsEndpoint}/update-theme-customization`, data);
		}
	};
}

export function Sidebar() {
	let sidebarEndpoint = `sidebar`;

	return {
		get(params) {
			return HTTP.get(sidebarEndpoint, {params});
		},
	}
}

export function Navbar() {
	let navbarEndpoint = `navbar`;

	return {
		get(params) {
			return HTTP.get(navbarEndpoint, {params});
		},
	}
}

export function ContentMigration() {
	let contentMigrationEndpoint = 'migration-content';

	return {
		get(params) {
			return HTTP.get(contentMigrationEndpoint, {params});
		},
		create(projectId, templateId, data) {
			return HTTP.post(`${contentMigrationEndpoint}/project/${projectId}/template/${templateId}/create`, data);
		},
		cancel(uid) {
			return HTTP.delete(`${contentMigrationEndpoint}/cancel`, {
				data: {uid}
			});
		},
		checkProgress(uid) {
			return HTTP.get(`${contentMigrationEndpoint}/check-progress`, {
				params: {uid}
			});
		},
	}
}
